<template>
  <div>
    <vue-headful title="Dit is jouw profiel!" />
    <Header page_title="Dit is jouw profiel!" />
    <div id="profile">
      <div class="container-fluid pt-5">
        <h1 class="sd-title bold small pb-4">
            Hi, ik ben {{ user.firstname }}
        </h1>

        <div class="profile-specs">
          <div class="avatar rounded-circle position-relative overflow-hidden mb-1">
            <span v-if="user.avatar" class="d-block image_background" :style="this.ImageBackground(user.avatar)"></span>
            <span v-else class="avatar-icon"><svg-icon icon="person_male" /></span>
          </div>
          <div class="profile-specs-info">
            <div class="salary"><svg-icon icon="suitcase"></svg-icon>&euro; {{ parseFloat(user.salary_per_hour).toFixed(2) }} per uur</div>
            <div class="location"><svg-icon icon="marker"></svg-icon>{{ user.city ? user.city : "" }}</div>
            <div class="customer-type"><svg-icon icon="file_contract" />{{ user.customer_type === 0 ? "Uitzendkracht" : "ZZP'er" }}</div>
          </div>
        </div>

        <div class="achievements_container">
          <achievements :achievements="user.achievements"></achievements>
        </div>
      </div>
      <!--      <svg-icon icon="wave" class="profile-wave"></svg-icon>-->
      <svg-icon icon="wave" class="seperator" />
      <div class="pt-4 px-4 pb-4 bg-gray">
        <div v-if="user.branch !== 3" id="calendar" class="container-fluid px-0">
          <div class="sd-row">
            <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="calendar" />Dagen</h2>
            <div class="position-relative sd-container small-radius bg-white text sd-top-column calendar-container">
              <div class="click-container" v-on:click="fakeCalendar">
                <div class="">
                  Toon alle beschikbare dagen
                </div>
                <div class="">
                  <svg-icon icon="calendar" />
                </div>
              </div>
              <div class="syncfusion-calendar position-absolute availability" v-show="show_calendar">
                <div class="icon-wrapper arrow-back">
                  <i class="material-icons-round">arrow_back</i>
                </div>
                <div class="icon-wrapper arrow-forward">
                  <i class="material-icons-round">arrow_forward</i>
                </div>
                <v-calendar
                    locale="nl"
                    :first-day-of-week="week"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :attributes="highlight"
                    :disabled-dates="disableDates"
                    ref="calendarInstance"
                    is-inline
                ></v-calendar>
              </div>
            </div>
          </div>
        </div>
          <div v-else class="container-fluid px-0">
              <div class="sd-row">
                  <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="calendar" />Dienst</h2>
                  <div class="position-relative sd-container small-radius bg-white text sd-top-column">
                      <div class="position-relative">
                          <label class="text text-yellow">Dienst</label>
                          <div class="details position-relative">
                              <p class="mb-2">
                                  {{ healthcareAvailabilityText }}
                              </p>
                              <p v-if="hasTransport">Beschikt over eigen vervoer.</p>
                              <p v-else></p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <div class="container-fluid px-0">
          <div>
            <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="blackboard"></svg-icon>Profielschets</h2>
            <div class="sd-container small-radius bg-white text" v-if="user.derect_about_candidate" v-html="user.derect_about_candidate"></div>
            <div class="sd-container small-radius bg-white text" v-else>
              Derect heeft een (digitale) kennismaking met iedere kandidaat. Hier vind je onze profielschets zodra die gereed is.
            </div>
          </div>
          <h2 class="title-with-icon sd-title text-yellow mini mb-4"><svg-icon icon="suitcase"></svg-icon>Ervaring</h2>

            <template v-if="branch !== '3'">
          <div class="tab-item-container" v-if="second_branch">
            <div class="tab-item" @click="activeTab='po'" :class="activeTab === 'po'?'active':''">Basisonderwijs</div>
            <div class="tab-item" @click="activeTab='vo'" :class="activeTab === 'vo'?'active':''">Voortgezet onderwijs</div>
          </div>
          <div v-if="activeTab === 'po'" class="sd-container small-radius bg-white text">
            <div v-if="subBranch !== '2'" class="primary-education">
              <div v-if="experience" class="years-experience">
                <label class="text text-yellow">Aantal jaar ervaring</label>
                <p>{{ experience.years_experience + " jaar" }}</p>
              </div>

              <div v-if="experience ? Object.keys(experience).length < 5 : false" class="position-relative mb-3">
                <div>
                  <router-link v-if="education ? Object.keys(education).length >= 5 : false" :to="{ name: 'applicant-step_2', params: { action: 'save' } }" class="btn btn-gray btn-block">
                    Wijzig
                  </router-link>
                  <router-link v-if="education ? Object.keys(education).length < 5 : false" :to="{ name: 'applicant-step_2', params: { action: 'next' } }" class="btn btn-gray btn-block">
                    Wijzig
                  </router-link>
                </div>
              </div>

              <div v-if="experience ? Object.keys(experience).length >= 5 : false" class="position-relative">
                <div class="position-relative mb-3">
                  <label class="text text-yellow">Recente functies</label>
                  <div class="details position-relative">
                    <p class="mb-2">
                      {{ !experience.position ? "-" : "" }}
                      <span v-for="(item, i) in experience.position" v-bind:key="i" class="d-inline-block position-relative">
                      {{ experience.position[i] }}<span v-if="i < experience.position.length - 1">,&nbsp;</span>
                    </span>
                    </p>
                  </div>
                </div>

                <div>
                  <label class="text text-yellow">Doelgroepen</label>
                  <div class="position-relative mb-3">
                    <div class="details position-relative">
                      <p class="mb-2">
                        {{ !experience.audience ? "-" : "" }}
                        <span v-for="(item, i) in experience.audience" v-bind:key="i" class="d-inline-block position-relative">
                        {{ item }}<span v-if="i < experience.audience.length - 1">,&nbsp;</span>
                      </span>
                      </p>
                    </div>
                  </div>
                  <label class="text text-yellow">Type onderwijs</label>
                  <div class="position-relative mb-3">
                    <div class="details position-relative">
                      <p class="mb-2">
                        {{ !experience.education_experience ? "-" : "" }}
                        <span v-for="(item, i) in experience.education_experience" v-bind:key="i" class="d-inline-block position-relative">
                        {{ item }}<span v-if="i < experience.education_experience.length - 1">,&nbsp;</span>
                      </span>
                      </p>
                    </div>
                  </div>
                  <label class="text text-yellow">Denominaties</label>
                  <div class="position-relative mb-3">
                    <div class="details position-relative">
                      <p class="mb-2">
                        {{ !experience.denomination ? "-" : "" }}
                        <span v-for="(item, i) in experience.denomination" v-bind:key="i" class="d-inline-block position-relative">
                        {{ item }}<span v-if="i < experience.denomination.length - 1">,&nbsp;</span>
                      </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="education ? Object.keys(education).length < 5 :false" class="position-relative">
                  <label class="text text-yellow">Opleiding</label>
                  <router-link :to="{ name: 'applicant-step_3', params: { action: 'save' } }" class="btn btn-gray btn-block">Wijzig</router-link>
                </div>
                <div class="position-relative">
                  <label class="text text-yellow">Opleidingen</label>
                  <div class="position-relative mb-3">
                    <div class="position-relative">
                      <p class="mb-2">
                      <span v-if="diplomas">
                        <span v-for="(item, i) in diplomas" v-bind:key="i" class="d-block position-relative">{{ item }}</span>
                      </span>
                        <span v-else>
                        <span class="d-block position-relative">Niet ingevuld</span>
                      </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="advanced-education">
              <div v-if="experience" class="years-experience">
                <label class="text text-yellow">Aantal jaar ervaring</label>
                <p>{{ experience.years_experience + " jaar" }}</p>
              </div>
              <div class="position-relative mb-3">
                <label class="text text-yellow">Recente functies</label>
                <div class="details position-relative">
                  <p class="mb-2">
                    {{ !experience.position ? "-" : "" }}
                    <span v-for="(item, i) in experience.position" v-bind:key="i" class="d-inline-block position-relative">
                      {{ experience.position[i] }}<span v-if="i < experience.position.length - 1">,&nbsp;</span>
                    </span>
                  </p>
                </div>
              </div>
              <div class="position-relative group_experience mb-3">
                <label class="text text-yellow">Doelgroepen</label>
                <div class="details position-relative">
                  <p class="mb-2">
                    {{ !experience.group_experience ? "-" : "" }}
                    <template v-for="(item, i) in experience.group_experience">
                      <span class="d-inline-block">{{ item }}<template v-if="i < experience.group_experience.length - 1">,&nbsp;</template></span>
                    </template>
                  </p>
                </div>
              </div>
              <div class="position-relative education_experience mb-3">
                <label class="text text-yellow">Type onderwijs</label>
                <div class="details position-relative">
                  <p class="mb-2">
                    {{ !experience.education_experience ? "-" : "" }}
                    <template v-for="(item, i) in experience.education_experience">
                      <span class="d-inline-block">{{ item }}<template v-if="i < experience.education_experience.length - 1">,&nbsp;</template></span>
                    </template>
                  </p>
                </div>
              </div>
              <div class="position-relative education_experience mb-3">
                <label class="text text-yellow">Bijzondere onderwijsvormen</label>
                <div class="details position-relative">
                  <p class="mb-2">
                    {{ !experience.special_education_experience ? "geen ervaring mee" : "" }}
                    <template v-for="(item, i) in experience.special_education_experience">
                      <span class="d-inline-block">{{ item }}<template v-if="i < experience.special_education_experience.length - 1">,&nbsp;</template></span>
                    </template>
                  </p>
                </div>
              </div>
              <div class="position-relative subject mb-3">
                <label class="text text-yellow">Vakken</label>
                <template v-for="(subjects, category) in experience.subject">
                  <div v-for="(items, subject) in subjects" class="details position-relative mb-1">
                    <label class="text text-yellow d-block mb-0">{{ subject }}</label>
                    <span v-for="(qualification, type) in items" class="d-block">
                      <template v-if="qualification != false && category !== 'Vmbo-profiel'" >
                        <span v-if="type === 'studying'">Studerend</span>
                        <span v-if="type === 'qualified'">Bevoegd</span>
                        <span v-if="type === 'experienced'">Ervaring</span>
                        <span v-if="type === 'can_also_give'">Kan ook geven</span>
                        <span v-if="qualification === 'Beide'">: 1e en 2e graads</span>
                        <span v-else>: {{ qualification }}</span>
                      </template>
                      <template v-if="qualification != false && category === 'Vmbo-profiel'" >
                        <span v-if="type === 'studying'">Studerend</span>
                        <span v-if="type === 'qualified'">Bevoegd</span>
                        <span v-if="type === 'experienced'">Ervaring</span>
                        <span v-if="type === 'can_also_give'">Kan ook geven</span>
                        <span></span>
                      </template>
                    </span>
                  </div>
                </template>
              </div>
              <div v-if="education[1] === 'YES'" class="position-relative education">
                <div class="position-relative mb-3">
                  <p class="mb-2">{{ user.firstname }} heeft (ook) een pabo diploma</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab === 'vo'" class="sd-container small-radius bg-white text">
            <div v-if="second_branch.experiences" class="years-experience">
              <label class="text text-yellow">Aantal jaar ervaring</label>
              <p>{{ second_branch.experiences.years_experience + " jaar" }}</p>
            </div>
            <div class="position-relative relevant-functions mb-3">
              <label class="text text-yellow">Recente functies</label>
              <div class="details position-relative">
                <p class="mb-2">
                  {{ !second_branch.experiences.position ? "-" : "" }}
                  <template v-for="(item, i) in second_branch.experiences.position">
                    <span class="d-inline-block">{{ item }}<template v-if="i < second_branch.experiences.position.length - 1">,&nbsp;</template></span>
                  </template>
                </p>
              </div>
            </div>
            <div class="position-relative group_experience mb-3">
              <label class="text text-yellow">Doelgroepen</label>
              <div class="details position-relative">
                <p class="mb-2">
                  {{ !second_branch.experiences.group_experience ? "-" : "" }}
                  <template v-for="(item, i) in second_branch.experiences.group_experience">
                    <span class="d-inline-block">{{ item }}<template v-if="i < second_branch.experiences.group_experience.length - 1">,&nbsp;</template></span>
                  </template>
                </p>
              </div>
            </div>
            <div class="position-relative education_experience mb-3">
              <label class="text text-yellow">Type onderwijs</label>
              <div class="details position-relative">
                <p class="mb-2">
                  {{ !second_branch.experiences.education_experience ? "-" : "" }}
                  <template v-for="(item, i) in second_branch.experiences.education_experience">
                    <span class="d-inline-block">{{ item }}<template v-if="i < second_branch.experiences.education_experience.length - 1">,&nbsp;</template></span>
                  </template>
                </p>
              </div>
            </div>
            <div class="position-relative education_experience mb-3">
              <label class="text text-yellow">Bijzondere onderwijsvormen</label>
              <div class="details position-relative">
                <p class="mb-2">
                  {{ !second_branch.experiences.special_education_experience ? "geen ervaring mee" : "" }}
                  <template v-for="(item, i) in second_branch.experiences.special_education_experience">
                    <span class="d-inline-block">{{ item }}<template v-if="i < second_branch.experiences.special_education_experience.length - 1">,&nbsp;</template></span>
                  </template>
                </p>
              </div>
            </div>
            <div class="position-relative subject mb-3">
              <label class="text text-yellow">Vakken</label>
              <template v-for="(subjects, category) in second_branch.experiences.subject">
                <div v-for="(items, subject) in subjects" class="details position-relative mb-1">
                  <label class="text text-yellow d-block mb-0">{{ subject }}</label>
                  <span v-for="(qualification, type) in items" class="d-block">
                      <template v-if="qualification != false && category !== 'Vmbo-profiel'" >
                        <span v-if="type === 'studying'">Studerend</span>
                        <span v-if="type === 'qualified'">Bevoegd</span>
                        <span v-if="type === 'experienced'">Ervaring</span>
                        <span v-if="qualification === 'Beide'">: 1e en 2e graads</span>
                        <span v-else>: {{ qualification }}</span>
                      </template>
                      <template v-if="qualification != false && category === 'Vmbo-profiel'" >
                        <span v-if="type === 'studying'">Studerend</span>
                        <span v-if="type === 'qualified'">Bevoegd</span>
                        <span v-if="type === 'experienced'">Ervaring</span>
                        <span v-if="type === 'can_also_give'">Kan ook geven</span>
                        <span></span>
                      </template>
                    </span>
                </div>
              </template>
            </div>
            <div v-if="second_branch.educations[1] === 'YES'" class="position-relative education">
              <div class="position-relative mb-3">
                <p class="mb-2">{{ user.firstname }} heeft (ook) een pabo diploma</p>
              </div>
            </div>
          </div>
            </template>
            <template v-else>
                <div class="sd-container small-radius bg-white text">
                    <div v-if="experience.group" class="years-experience">
                        <label class="text text-yellow">Doelgroepen </label>
                        <p>{{ experience.group.join(', ') }}</p>
                    </div>

                    <div v-if="experience.qualification" class="years-experience">
                        <label class="text text-yellow">Bevoegde zorgfunctie(s)</label>
                        <p>{{ experience.qualification.join(', ') }}</p>
                    </div>

                    <div v-if="experience.specialization" class="years-experience">
                        <label class="text text-yellow">Gespecialiseerde type zorg</label>
                        <p>{{ experience.specialization.join(', ') }}</p>
                    </div>
                </div>
            </template>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";
import VueSlideBar from "vue-slide-bar";
// import Education from "@/components/Education.vue";
// import Experience from "@/components/Experience.vue";
// import ReviewCard from "@/components/ReviewCard.vue";

export default {
  data: function() {
    return {
      branch: 0,
      subBranch: 0,
      user: "",
      profession: "",
      address: "",
      second_branch: null,
      experience: null,
      education: null,
      diplomas: false,
      workfield: null,
      activeTab: 'po',
      guide: {
        1: [
          { url: 1, label: "Opgeleid als leerkracht" },
          { url: "1_YES", label: null },
          { url: "1_STUDYING_A", label: null },
          { url: "1_STUDYING_B", label: null }
        ],
        2: [
          { url: 2, label: "Onderwijsassistent" },
          { url: "2_YES", label: null },
          { url: "2_YES_EXTRA", label: "Zelfstandig voor de klas" },
          { url: "2_STUDYING_A", label: null },
          { url: "2_STUDYING_B", label: null }
        ],
        3: [
          { url: 3, label: "1e of 2e graad" },
          { url: "3_YES", label: null },
          { url: "3_STUDYING_A", label: null },
          { url: "3_STUDYING_B", label: null }
        ],
        4: [
          { url: 4, label: "Master EN (SEN)" },
          { url: "4_YES", label: null },
          { url: "4_STUDYING_A", label: null },
          { url: "4_STUDYING_B", label: null }
        ],
        5: [
          { url: 5, label: "Buitenlandse lesbevoegdheid" },
          { url: "5_YES", label: null }
        ]
      },
      reviews: null,
      // reviews: [
      //   {
      //     details:
      //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      //     date: "juli 2019",
      //     author: "Joke",
      //     company: "Directeur basisschool"
      //   }
      // ]
      show_calendar: false,
      dates: [],
      minDate: new Date(),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 5)),
      week: 2,
      highlight: []
    };
  },
  async created() {},
  async mounted() {
    this.fetchData();
  },
    computed: {
        healthcareAvailabilityText() {
            const raw = this.user.healthcare_availability;
            if (!raw) return 'Nog niet ingevuld';

            let parsed;
            try {
                parsed = JSON.parse(raw);
            } catch {
                return 'Nog niet ingevuld';
            }

            // Map internal keys back to your original labels
            const labelMap = {
                day: 'Dag',
                evening: 'Avond',
                night: 'Nacht',
                weekend: 'Weekend',
                isFlexible: 'Ik ben flexibel'
            };

            return Object.keys(parsed)
                .filter(key => parsed[key] === true && key !== 'hasTransport')
                .map(key => labelMap[key])
                .join(', ') || 'Nog niet ingevuld';
        },

        hasTransport() {
            const raw = this.user.healthcare_availability;
            if (!raw) return false;

            try {
                const parsed = JSON.parse(raw);
                return !!parsed.hasTransport;
            } catch {
                return false;
            }
        }
    },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.branch = localStorage.getItem("branch");
      this.subBranch = localStorage.getItem("subBranch");

      var minDate = new Date();
      minDate.setHours(0, 0, 0, 0);
      minDate.setDate(minDate.getDate() + 1);
      this.minDate = minDate;

      var maxDate = new Date();
      maxDate.setMonth(maxDate.getMonth() + 5);
      maxDate.setHours(0, 0, 0, 0);
      this.maxDate = maxDate;

      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.experience) {
        this.experience = JSON.parse(this.user.experience);
      }
      if (this.user.education) {
        this.education = JSON.parse(this.user.education);
        this.diplomas = this.printDiplomas();
      }
      if (this.user.second_branch) {
        this.second_branch = JSON.parse(this.user.second_branch);
      }
      if (this.user.workfield != null) {
        this.workfield = this.getWorkfieldByNumber(this.user.workfield);
      }
      // this.experiences = await this.getTokenAPIList(
      //   "applicant/answers/experience"
      // );
      // if (this.user.search_profession_id) {
      //   this.profession = await this.getAPIList(
      //     "professions",
      //     this.user.search_profession_id
      //   );
      // } else {
      //   this.profession = "-";
      // }

      // this.address = [
      //   this.user.street,
      //   this.user.street_number + ",",
      //   this.user.postal_code,
      //   this.user.city
      // ].join(" ");
      // this.educations = this.user.educations.length
      //   ? this.user.educations
      //   : null;
      // this.experiences = this.user.experiences.length
      //   ? this.user.experiences
      //   : null;
      // if (this.user.search_availability) {
      //   var dates = JSON.parse(this.user.search_availability);
      //   for (var key in dates) {
      //     this.dates.push(this.formatNoTime(dates[key]));
      //   }
      // }
      this.loadDates();
      this.$forceUpdate();
      this.$store.state.loading = false;
    },
    scrollToReviews() {
      var element = document.getElementById("reviews");
      var top = element.offsetTop;
      // window.scrollTo(0, top);
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    },
    loadDates: function() {
      const user = JSON.parse(localStorage.getItem("user"));

      if (user.search_availability) {
        var array = [];
        var dates = JSON.parse(user.search_availability);

        for (var key in dates) {
          // let _date = new Date(dates[key] + " 10:00:00"); //wrong format
          let _date = dates[key];
          _date = _date.split('-');
          let _y = parseInt(_date[0]);
          let _m = parseInt(_date[1]) - 1;
          let _d = parseInt(_date[2]);

          _date = new Date(_y, _m, _d, 0, 0, 0);

          array.push(_date);
          this.dates.push(dates[key]);

        }

        if (array.length) {
          this.highlight = [
            {
              highlight: true,
              dates: array
            }
          ];
        }
      }
    },
    disableDates: function(args) {
      // { weekdays: [1, 7] }
      var ymd = args.id;
      if (this.dates.indexOf(ymd) > -1) {
        args.classes.push('highlight');
      }
      args.isDisabled = true;
      return args;
    },
    fakeCalendar() {
      this.show_calendar = this.show_calendar ? false : true;
    },
    translate(answer) {
      if (answer == "NO") {
        return "Nee";
      }
      if (answer == "YES") {
        return "Ja";
      }
      if (answer == "STUDYING") {
        return "Studerend";
      }
      return answer;
    },
    elContains(str, target) {
      return str.includes(target);
    },
    printDiplomas() {
      var diplomas = [];

      if (this.education["1_YES"]) {
        diplomas.push("Pabo (diploma, " + this.education["1_YES"] + ")");
      }
      if (this.education["1_STUDYING_A"]) {
        diplomas.push( "Pabo " + "(" + this.education["1_STUDYING_A"] + ", " + this.education["1_STUDYING_B"] + ")");
      }
      if (this.education["2_YES"]) {
        diplomas.push("Onderwijsassistent (diploma, " + this.education["2_YES"] + ")");
      }
      if (this.education["2_STUDYING_A"]) {
        diplomas.push("Onderwijsassistent " + "(" + this.education["2_STUDYING_A"] + ", " + this.education["2_STUDYING_B"] + ")");
      }
      if (this.education["3_YES"]) {
        diplomas.push("Eerste- of tweedegraads docent (diploma, " + this.education["3_YES"] + ")");
      }
      if (this.education["3_STUDYING_A"]) {
        diplomas.push("Eerste- of tweedegraads docent " + "(" + this.education["3_STUDYING_A"] + ", " + this.education["3_STUDYING_B"] + ")");
      }
      if (this.education["4_YES"]) {
        diplomas.push("Master (SEN) (diploma, " + this.education["4_YES"] + ")");
      }
      if (this.education["4"] == "STUDYING") {
        diplomas.push("Master (SEN) (Studerend)");
      }
      if (this.education["5_YES"]) {
        diplomas.push("Buitenlandse bevoegheid (diploma, " + this.education["5_YES"] + ")");
      }
      if (this.education["5"] == "STUDYING") {
        diplomas.push("Buitenlandse bevoegheid (Studerend)");
      }

      if (diplomas.length >= 1) {
        return diplomas;
      } else {
        return false;
      }
    },
    getWorkfieldByNumber(workfieldNumber) {
      switch (workfieldNumber) {
        case 0:
          return "Dagopvang en BSO";
        case 1:
          return "Dagopvang";
        case 2:
          return "BSO";
        case 3:
          return "-";
        case 4:
        case 5:
        case 6:
        case 7:
          return "Diploma's nog niet geverifieerd";
        default:
          return null;
      }
    }
  },
  ready() {
    this.$forceUpdate();
  },
  components: {
    Achievements
    // Education,
    // Experience,
    // ReviewCard
  }
};
</script>

<style scoped>
.btn-sm {
  background-color: #FFCD00;
  font: 13px/35px "Real Head Pro";
  font-weight: normal;
  color: #625a55;
  height: 35px;
  padding: 0 15px;
  border-radius: 4px;
}
.seperator {
  display: block;
  width: 100%;
  color: #F6F6F6;
}
#profile .avatar {
  border-width: 2px;
}
.add-comma span:not(:last-child):after {
  content: ",";
  margin-right: 5px;
}
#profile .info-group > div > div:not(:first-child) .details:before {
  display: none;
}
#profile .info-group > div > div:not(:first-child) .details > div {
  display: inline-block;
}
#profile .info-group > div > div:not(:first-child) .details > div strong {
  font-family: "Real Head Pro";
  font-weight: 200;
  font-size: 14px;
  line-height: 22px;
}
#profile
  .info-group
  > div
  > div:not(:first-child)
  .details
  > div.text:not(:first-child) {
  display: inline-block;
  padding-left: 3px;
}
#profile #calendar > div {
  padding-top: 0;
}
#profile #calendar + div {
  min-height: 350px;
}
.achievements_container {
  position: relative;
  z-index: 5;
  display: inline-block;
}
/deep/ .achievements_container .achievement {
  margin-top: 30px;
}
.title-with-icon {
  display: flex;
  align-items: center;
}
/deep/ .title-with-icon .svg-container {
  display: flex;
  align-items: center;
}
/deep/ .title-with-icon svg {
  color: #ffcd00;
  margin-right: 15px;
  width: 15px;
}

#profile .tab-item-container {
  display: flex;
}

#profile .tab-item-container .tab-item {
  border: 1px solid #64513D;
  border-bottom: 0;
  padding: 5px 15px;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  cursor: pointer;
}

#profile .tab-item-container .tab-item.active {
  background-color: #FFF;
  border-color: #FFF;
}

#profile .tab-item-container .tab-item:not(:last-child) {
  margin-right: 10px;
}

.avatar .avatar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.avatar .avatar-icon /deep/.svg-container svg {
  height: 60px;
  width: 60px;
  color: #FFF;
}

.sd-row .syncfusion-calendar {
  top: 70px;
  left: 0;
  z-index: 1;
}

.sd-row .calendar-container .click-container {
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
